module.exports = __webpack_public_path__ + "static/media/event-logo.66f54042.png";